import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { Button, Form, Row, Col } from 'react-bootstrap';
import '../../Modal.css';

Modal.setAppElement('#root'); // This is necessary for accessibility reasons

const DeviceModalMessageEdit = ({
  isOpen,
  onRequestClose,
  handleCreateMsg,
  selectedDevice,
}) => {
  const [selectedFirmwareMin, setSelectedFirmwareMin] = useState(0);
  const [selectedFirmwareMax, setSelectedFirmwareMax] = useState(999);
  const [selectedMessage, setSelectedMessage] = useState('');
  const [selectedCriticity, setSelectedCriticity] = useState(0);

  const preWrittenMessages = [
    'You are using an outdated firmware. Please update your firmware to enjoy new features and bug fixes.',
    'Your firmware contains a critical bug. Please update your firmware to enjoy new features and bug fixes.',
    'The feature xxx is now available. Check in settings section xxx.',
    'Vous utilisez un firmware obsolète. Veuillez mettre à jour votre firmware pour profiter des nouvelles fonctionnalités et des corrections de bugs.',
    'Votre firmware contient un bug critique. Veuillez mettre à jour votre firmware pour profiter des nouvelles fonctionnalités et des corrections de bugs.',
    'La fonctionnalité xxx est maintenant disponible. Consultez la section des paramètres xxx.',
  ];

  useEffect(() => {
    // Reset fields for new message creation
    setSelectedFirmwareMin(0);
    setSelectedFirmwareMax(999);
    setSelectedMessage('');
    setSelectedCriticity(0);
  }, [selectedDevice]);

  const handleSave = () => {
    handleCreateMsg({
      fwMin: selectedFirmwareMin,
      fwMax: selectedFirmwareMax,
      msg: selectedMessage,
      criticity: selectedCriticity,
    });
    onRequestClose();
  };

  const handlePreWrittenMessageChange = (e) => {
    const message = e.target.value;
    setSelectedMessage(message);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="modal-content"
      overlayClassName="modal-overlay"
      contentLabel={"Create Message Modal"}
    >
      <div className="modal-header">
        <h5 className="modal-title">Send Message</h5>
        <button type="button" className="close" onClick={onRequestClose}>
          <span>&times;</span>
        </button>
      </div>
      <div className="modal-body" style={{ overflowY: 'auto' }}>
        <Form>
          <Row className="align-items-center">
            <Form.Group as={Col} controlId="maintenanceLevel" sm={6}>
              <Form.Label>Maintenance Level:</Form.Label>
              <Form.Control
                type="text"
                value={selectedDevice?.maintenanceLevel || 'failed to fetch'}
                readOnly
                plaintext
                className="inline-text"
                style={{ color: 'var(--foreground-color)' }}
              />
            </Form.Group>

            <Form.Group as={Col} controlId="firmwareVersion" sm={6}>
              <Form.Label>Firmware Version:</Form.Label>
              <Form.Control
                type="text"
                value={selectedDevice?.version || ''}
                readOnly
                plaintext
                className="inline-text"
                style={{ color: 'var(--foreground-color)' }}
              />
            </Form.Group>
          </Row>

          <Form.Group controlId="firmwareMin">
            <Form.Label>Minimal Firmware Level</Form.Label>
            <Form.Control
              type="text"
              value={selectedFirmwareMin}
              onChange={(e) => setSelectedFirmwareMin(e.target.value)}
              placeholder="Enter min firmware"
              className="custom-input"
            />
          </Form.Group>

          <Form.Group controlId="firmwareMax">
            <Form.Label>Maximal Firmware Level</Form.Label>
            <Form.Control
              type="text"
              value={selectedFirmwareMax}
              onChange={(e) => setSelectedFirmwareMax(e.target.value)}
              placeholder="Enter max firmware"
              className="custom-input"
            />
          </Form.Group>

          <Form.Group controlId="criticity">
            <Form.Label>Criticity</Form.Label>
            <Form.Control
              as="select"
              value={selectedCriticity}
              onChange={(e) => setSelectedCriticity(Number(e.target.value))}
              className="custom-input"
            >
              <option value={0}>Normal</option>
              <option value={1}>Critical</option>
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="preWrittenMessage">
            <Form.Label>Pre-written Message</Form.Label>
            <Form.Control
              as="select"
              value={selectedMessage}
              onChange={handlePreWrittenMessageChange}
              className="custom-input"
            >
              <option value="">Select a Message</option>
              {preWrittenMessages.map((msg, index) => (
                <option key={index} value={msg}>
                  {msg}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="modifyMessage">
            <Form.Label>Message</Form.Label>
            <Form.Control
              as="textarea"
              value={selectedMessage}
              onChange={(e) => setSelectedMessage(e.target.value)}
              placeholder="Modify the message here"
              className="custom-input"
              style={{
                resize: 'vertical',
                height: '100px',
              }}
            />
          </Form.Group>

        </Form>
      </div>
      <div className="modal-footer">
        <Button variant="secondary" onClick={onRequestClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={!selectedMessage.trim()}
        >
          Create
        </Button>
      </div>
    </Modal>
  );
};

export default DeviceModalMessageEdit;
